export const Valozhyn = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [27.027105224318234, 53.91172776919154],
            [27.03300173092282, 53.91520085835219],
            [27.037912033656823, 53.92282473598766],
            [27.037912033656823, 53.92624188469068],
            [27.041036771270342, 53.93176130266812],
            [27.050410985907604, 53.93780554273553],
            [27.060677982206812, 53.93990768128958],
            [27.072730542728152, 53.94043319964322],
            [27.083890321587546, 53.94227246148648],
            [27.09594288300741, 53.94673890197504],
            [27.1021923591328, 53.95225560915611],
            [27.10844183525819, 53.95645832518602],
            [27.11245935543195, 53.96039798643392],
            [27.112905746262925, 53.96512508906022],
            [27.110227399480323, 53.96932650740166],
            [27.10576348847559, 53.97379005069911],
            [27.103085141693043, 53.97746555093255],
            [27.10353153252396, 53.98324068201964],
            [27.107549052697777, 53.988227650996976],
            [27.11469131138341, 53.99163944373703],
            [27.12272635173099, 53.993738869526],
            [27.128529437025406, 53.99610059681527],
            [27.132993348928608, 53.99846219014046],
            [27.142367562667403, 53.99977412872363],
            [27.151295385575395, 53.9995117439978],
            [27.158884035091944, 53.997675007249995],
            [27.167365467168963, 53.99793740302465],
            [27.174507725854596, 53.998724580953535],
            [27.18120359281096, 54.00266024786089],
            [27.18298915703315, 54.006857881691644],
            [27.19236337167041, 54.0107927796202],
            [27.1986128477958, 54.01577644870633],
            [27.1986128477958, 54.01866145825528],
            [27.197273674404414, 54.02495533024472],
            [27.195041718452785, 54.027839703235486],
            [27.19057780744805, 54.03124824991136],
            [27.19013141571878, 54.0343943523809],
            [27.19236337167041, 54.03885092355347],
            [27.193256154230653, 54.04199645073777],
            [27.191916980839437, 54.0461901170608],
            [27.186560286375936, 54.04671429572977],
            [27.18388193959339, 54.04645220695812],
            [27.180757201979816, 54.04514173988764],
            [27.173614943294183, 54.04461754191084],
            [27.172275769903024, 54.04671429572977],
            [27.172275769903024, 54.05090748548042],
            [27.17182937907205, 54.05405210077282],
            [27.170043813951395, 54.05693445487776],
            [27.168258249729206, 54.059554603924994],
            [27.168481445144607, 54.06644808102948],
            [27.168999612811774, 54.068272428941896],
            [27.170573903512434, 54.07381514056948],
            [27.1698764173899, 54.0799533584663],
            [27.1698764173899, 54.086090668727024],
            [27.165691500654418, 54.08936352948473],
            [27.160809096898106, 54.08936352948473],
            [27.158019152407746, 54.08690890811795],
            [27.157321666285213, 54.081999229222845],
            [27.150346804161245, 54.07217812930662],
            [27.143371942935403, 54.068903912606004],
            [27.13500210856637, 54.0652201107751],
            [27.126632274197163, 54.06194534537798],
            [27.11477500921518, 54.059489102265786],
            [27.110590092479697, 54.06112661381326],
            [27.112682550847353, 54.064810779287654],
            [27.11547249623601, 54.06726670769319],
            [27.116867468481132, 54.07176886640519],
            [27.117564954603665, 54.0754520872851],
            [27.11547249623601, 54.079544172213275],
            [27.10849763411187, 54.0799533584663],
            [27.096640369129943, 54.08036254068526],
            [27.082690645780133, 54.08281754928845],
            [27.0743208114111, 54.08322670327044],
            [27.062463546428944, 54.08690890811795],
            [27.05548868520333, 54.09018170433865],
            [27.04223644797605, 54.095090415184075],
            [27.035959071974673, 54.09549944816064],
            [27.02410180699269, 54.09549944816064],
            [27.017824431889437, 54.09549944816064],
            [27.005967166907453, 54.09590847710416],
            [27.00108476315114, 54.09590847710416],
            [26.992017442659403, 54.097135539735575],
            [26.980857663799952, 54.097135539735575],
            [26.973185316451747, 54.09549944816064],
            [26.9669079404502, 54.09386329205438],
            [26.959933079224527, 54.092636132625046],
            [26.95295821710056, 54.09222707141544],
            [26.939008493750805, 54.095090415184075],
            [26.934823577015322, 54.098362566068545],
            [26.930638659381543, 54.10327030895496],
            [26.927848714891184, 54.10776856315357],
            [26.92366379815593, 54.11267519247258],
            [26.92017636754298, 54.114310607066386],
            [26.915777985943294, 54.1139731151294],
            [26.911755465746523, 54.1139731151294],
            [26.907915787744457, 54.11354440349987],
            [26.903527584056917, 54.11225824306234],
            [26.90060211523138, 54.1099001790605],
            [26.898042329896555, 54.106684420227566],
            [26.89603106934908, 54.10411163432201],
            [26.892922759227076, 54.102396354333564],
            [26.888168872048595, 54.101217058647364],
            [26.883780668361055, 54.10089542653958],
            [26.879889565402323, 54.09857524706831],
            [26.87765761034899, 54.09543400319757],
            [26.87765761034899, 54.089412620662756],
            [26.876318436059478, 54.086008843689626],
            [26.870515351663357, 54.08260478749713],
            [26.863373092977724, 54.08155732969948],
            [26.8499813581667, 54.08260478749713],
            [26.839714361867493, 54.08653251998095],
            [26.836143232524705, 54.092292521437685],
            [26.83301849491113, 54.097004654868556],
            [26.824537062834338, 54.10093102386185],
            [26.819180369269134, 54.10197799317149],
            [26.81427006653513, 54.10197799317149],
            [26.800878331724107, 54.10407185197391],
            [26.795968028989932, 54.10485702170331],
            [26.788379379473326, 54.10354839705275],
            [26.78480825013048, 54.09988402864849],
            [26.781683512516963, 54.096742883895615],
            [26.777219600613876, 54.09412508119942],
            [26.771416516217755, 54.093339708281405],
            [26.76204230158072, 54.09569578243054],
            [26.76025673735836, 54.100407529822235],
            [26.758024781406903, 54.10354839705275],
            [26.753114478672728, 54.105903891374794],
            [26.74463304659588, 54.105903891374794],
            [26.730794920953883, 54.107212441693775],
            [26.721420707214975, 54.11009110682812],
            [26.718742360432373, 54.11401623695872],
            [26.724991836557763, 54.11872590310202],
            [26.733026876905342, 54.11977242261577],
            [26.74284748237352, 54.12081891570489],
            [26.750436131890126, 54.12448143421631],
            [26.755346434624357, 54.128666773459656],
            [26.756685608015516, 54.13468245765523],
            [26.750436131890126, 54.13808224083573],
            [26.743740264933763, 54.137820729162456],
            [26.73882996219976, 54.13991277789489],
            [26.731241312683153, 54.142004720426826],
            [26.725438227388736, 54.14174323352091],
            [26.718742360432373, 54.1393897754873],
            [26.71383205769837, 54.13860525975514],
            [26.70713618984371, 54.1404357731717],
            [26.70535062562135, 54.14383508411589],
            [26.709814536626254, 54.147234115499884],
            [26.712492884307153, 54.14958712826922],
            [26.714278448529342, 54.1524628506898],
            [26.715171231089528, 54.157952311180566],
            [26.715171231089528, 54.16474777760391],
            [26.711153710915767, 54.169190363916584],
            [26.711153710915767, 54.174416325822165],
            [26.708028972403895, 54.17729032272041],
            [26.704904234790376, 54.17833536346569],
            [26.700440322887346, 54.17702905867088],
            [26.698654758665157, 54.174416325822165],
            [26.696422802713528, 54.17049691628904],
            [26.69285167337074, 54.17023560932614],
            [26.68883415319692, 54.17023560932614],
            [26.687494979805535, 54.17128082780039],
            [26.68660219724535, 54.173632473204464],
            [26.68437024129372, 54.17624525609352],
            [26.679906330288986, 54.17885787393578],
            [26.674996027554926, 54.17911912643223],
            [26.67187128904311, 54.17911912643223],
            [26.66606820464699, 54.17624525609352],
            [26.66294346613512, 54.17337118604814],
            [26.658479554232088, 54.17337118604814],
            [26.654015643227297, 54.1759839854422],
            [26.655354816618512, 54.18120908856713],
            [26.657140380840872, 54.184605051301276],
            [26.658479554232088, 54.187739539273366],
            [26.65758677257014, 54.191134965666606],
            [26.65044451388451, 54.1932243204983],
            [26.64642699371052, 54.1932243204983],
            [26.6401775175853, 54.189045505748595],
            [26.639284735024887, 54.18669473617865],
            [26.637499170802755, 54.1825152613298],
            [26.63169608550828, 54.18147032621022],
            [26.625000218551918, 54.18225402976259],
            [26.622768262600516, 54.18564990720512],
            [26.622768262600516, 54.189045505748595],
            [26.622321871769543, 54.19191848603907],
            [26.61919713325767, 54.195052419540616],
            [26.611608483740895, 54.19557471825118],
            [26.60491261678453, 54.19557471825118],
            [26.596877575538656, 54.19426895857339],
            [26.59152088197368, 54.192440824878474],
            [26.587056970070478, 54.19035143044249],
            [26.5817002765055, 54.18852312400418],
            [26.574111626988895, 54.187217141026565],
            [26.569647715983933, 54.18695593969045],
            [26.55804154539527, 54.19087378908398],
            [26.551345678438906, 54.194007801267105],
            [26.54554259314449, 54.19531356972084],
            [26.538846726188126, 54.198969501614215],
            [26.532150859231933, 54.20027511331119],
            [26.52724055649776, 54.20027511331119],
            [26.52277664459467, 54.20393060629863],
            [26.52277664459467, 54.207846846878624],
            [26.524115817985887, 54.21150167000542],
            [26.525454991377273, 54.217766329006395],
            [26.525454991377273, 54.22142027447438],
            [26.529472511551035, 54.22690058618832],
            [26.537061161965937, 54.23055372337592],
            [26.54598898487376, 54.23446744052097],
            [26.55491680778175, 54.23733726316732],
            [26.56116628390714, 54.24177205233059],
            [26.563398239858543, 54.24568470516289],
            [26.561612674738114, 54.250640199764234],
            [26.55848793712454, 54.25220496900607],
            [26.550899287607933, 54.25324811534517],
            [26.543310638091327, 54.2550735586089],
            [26.538400335357153, 54.25637739711044],
            [26.529472511551035, 54.25898494991981],
            [26.52188386203443, 54.25950644090483],
            [26.51652716846928, 54.25950644090483],
            [26.506706563001046, 54.2605494025637],
            [26.495546784141652, 54.2605494025637],
            [26.484833397011528, 54.2605494025637],
            [26.477691138325895, 54.26211379584885],
            [26.473673618152077, 54.264720986435634],
            [26.47010248880929, 54.26915283162282],
            [26.469209706248876, 54.27384485406526],
            [26.46563857690603, 54.28036066613822],
            [26.46270562631895, 54.28785121184194],
            [26.45569866056485, 54.286974768470884],
            [26.4440717485125, 54.28645269403671],
            [26.437811101900877, 54.27757641062283],
            [26.4351279691806, 54.271831912812615],
            [26.430656079514563, 54.26556427667009],
            [26.425289811375706, 54.25877326027785],
            [26.41634603294318, 54.2525036384323],
            [26.403824742418067, 54.24152950468306],
            [26.38862031737392, 54.23055245083509],
            [26.384148427707885, 54.22636994861426],
            [26.368049625090123, 54.219049548997646],
            [26.35731709061139, 54.21329689613498],
            [26.33853515437403, 54.21015874872745],
            [26.320647596609433, 54.2080665164566],
            [26.29739377070598, 54.20963570032745],
            [26.27682307842241, 54.214865881255434],
            [26.268773676663898, 54.2200954002825],
            [26.255358008565338, 54.22584710615905],
            [26.24373109561367, 54.23002966143986],
            [26.231209805088497, 54.23002966143986],
            [26.22137164728383, 54.228461252784655],
            [26.214458702647335, 54.22730663899307],
            [26.20258971194579, 54.22532425650928],
            [26.18738528780085, 54.22636994861426],
            [26.177547129996185, 54.22270991113356],
            [26.172180862756704, 54.21695776818649],
            [26.16234270495204, 54.20963570032745],
            [26.133722611809105, 54.19760377049778],
            [26.114046298897676, 54.187138374236724],
            [26.1051025186664, 54.184521611483376],
            [26.08989809452163, 54.18033444537832],
            [26.076482425523523, 54.18138127692458],
            [26.07290491433048, 54.187661706822496],
            [26.07111615828427, 54.19341792999353],
            [26.067538647091, 54.19760377049778],
            [26.060383622905988, 54.19812696998383],
            [26.052334222046852, 54.19551090240628],
            [26.051439844473293, 54.19184813008724],
            [26.04875670995426, 54.184521611483376],
            [26.04875670995426, 54.17928758775196],
            [26.044284821187603, 54.174052903019174],
            [26.03444666338288, 54.16567602752673],
            [26.023714128903976, 54.16043961879342],
            [26.020353242301212, 54.15768449598369],
            [26.01924223923811, 54.156773739316634],
            [26.013875971998687, 54.14891718907711],
            [26.01477035047145, 54.14263087401571],
            [26.02103099528432, 54.13215156344387],
            [26.035341041855702, 54.12743500781943],
            [26.046073576334607, 54.12166959987229],
            [26.068433024664444, 54.118000285884534],
            [26.08989809452163, 54.118000285884534],
            [26.10241938594595, 54.120621257465075],
            [26.10599689713922, 54.125338589204716],
            [26.103313763519395, 54.13372362874264],
            [26.096158740233705, 54.14158306310799],
            [26.10241938594595, 54.143678659742534],
            [26.108680030758876, 54.14472641848948],
            [26.11672943251733, 54.14105914686212],
            [26.125673210950026, 54.14105914686212],
            [26.135511367855372, 54.14682185684336],
            [26.139983257521408, 54.14420254271329],
            [26.144455147187443, 54.138963417128025],
            [26.133722611809105, 54.12900725208311],
            [26.131039479088656, 54.12166959987229],
            [26.129250723042446, 54.11275784629771],
            [26.129250723042446, 54.10699039688933],
            [26.136405746328307, 54.10017328486924],
            [26.144455147187443, 54.0938795719847],
            [26.14892703685325, 54.083912573706414],
            [26.14892703685325, 54.07814111152322],
            [26.15071579289969, 54.066595779671616],
            [26.156082060139113, 54.054522227419056],
            [26.15965957223159, 54.04454577546721],
            [26.16413146099825, 54.0335163837741],
            [26.17128648518326, 54.02458568508138],
            [26.180230263615783, 54.0177550337678],
            [26.189174042947855, 54.01460204754653],
            [26.20974473523148, 54.01460204754653],
            [26.22494915937625, 54.01722955270168],
            [26.241047961994013, 54.021958644875724],
            [26.26251303185103, 54.02878860640914],
            [26.280400589615624, 54.03666793737551],
            [26.29381625861356, 54.04034444773811],
            [26.308126305184885, 54.04454577546721],
            [26.317070084516786, 54.04664628060152],
            [26.327802618995747, 54.04086963652463],
            [26.331380131088338, 54.03194051794054],
            [26.332274509561103, 54.021958644875724],
            [26.332274509561103, 54.01039769269954],
            [26.335852019854997, 53.99935924123605],
            [26.334957643180758, 53.989369548566],
            [26.330485753514893, 53.98411085283362],
            [26.327802618995747, 53.97937745920245],
            [26.329591375041957, 53.97306542982574],
            [26.33674639832759, 53.97253938398546],
            [26.344795800086274, 53.97253938398546],
            [26.3537395785188, 53.976747562750006],
            [26.366260869043913, 53.98148125585544],
            [26.377887782895016, 53.98516264504002],
            [26.387725939800305, 53.987266150312564],
            [26.400247230325476, 53.990947027783136],
            [26.403824742418067, 53.984636752084555],
            [26.41276852085059, 53.976221563674244],
            [26.423501055329496, 53.96622631948924],
            [26.432444835560773, 53.958333643482945],
            [26.437811101900877, 53.94570225435558],
            [26.437811101900877, 53.93359358177844],
            [26.429761701941118, 53.92885444957335],
            [26.41097976480438, 53.92516808443969],
            [26.39935285275203, 53.92253476786527],
            [26.38325405013444, 53.9209546986005],
            [26.370732759609325, 53.91779437930734],
            [26.365366491470525, 53.913053452055294],
            [26.368049625090123, 53.90725825586395],
            [26.376099026848635, 53.90040834916607],
            [26.37856750938306, 53.89593949741004],
            [26.379092985742545, 53.89005591277652],
            [26.388412908348528, 53.890742479338314],
            [26.39957268720792, 53.89100554863501],
            [26.405375771604042, 53.89126861627591],
            [26.416535550463436, 53.89232087133979],
            [26.424570591709312, 53.893636152649094],
            [26.430373676105432, 53.893636152649094],
            [26.433944805448277, 53.89153168279029],
            [26.433944805448277, 53.88863786376584],
            [26.433944805448277, 53.88416520399443],
            [26.438408717351308, 53.87995520449499],
            [26.44331902008554, 53.87785004576625],
            [26.450014887041903, 53.876007945265485],
            [26.458942709949667, 53.87390258780465],
            [26.46474579524414, 53.87179712434988],
            [26.47233444476069, 53.869428351462886],
            [26.479030311717054, 53.86705944442048],
            [26.49152926396789, 53.86337421107066],
            [26.500903478604926, 53.86047844279608],
            [26.508938518952675, 53.858372303570945],
            [26.515187995078065, 53.85784575206793],
            [26.523223035425644, 53.858372303570945],
            [26.528579729888918, 53.85968865307609],
            [26.536168379405694, 53.86153147238991],
            [26.542864246362058, 53.862847722510935],
            [26.550452895878664, 53.86311096735409],
            [26.56116628390714, 53.85916211813742],
            [26.566969368303262, 53.85784575206793],
            [26.575004409549138, 53.8575824740966],
            [26.590181708582293, 53.85784575206793],
            [26.595538402147497, 53.85784575206793],
            [26.609376527789493, 53.85600277042346],
            [26.616072395644153, 53.85336979809529],
            [26.61919713325767, 53.84942002953079],
            [26.620982698378157, 53.8467866430596],
            [26.62767856533452, 53.84151937364504],
            [26.632142476339254, 53.84099261009652],
            [26.640623908416273, 53.83993906364856],
            [26.649998123053365, 53.838885490692064],
            [26.659372336792273, 53.83783189069652],
            [26.67008572482075, 53.83625144152853],
            [26.679459938559717, 53.83361722668019],
            [26.687048588076266, 53.83150973614073],
            [26.693298064201713, 53.82992904784993],
            [26.701779496278505, 53.82861176283603],
            [26.70535062562135, 53.828348300438165],
            [26.710707319186497, 53.82992904784993],
            [26.714278448529342, 53.83150973614073],
            [26.721420707214975, 53.831246291969535],
            [26.728116574171338, 53.829665594267055],
            [26.7321340943451, 53.82913868160051],
            [26.73838357047049, 53.829665594267055],
            [26.74731139337831, 53.83203661845221],
            [26.754900043793384, 53.833353796294375],
            [26.761149519918604, 53.832300057652446],
            [26.76338147497188, 53.83019250030583],
            [26.764274257532122, 53.82386919198217],
            [26.765167040092535, 53.82018015481361],
            [26.769184560266353, 53.8178084595192],
            [26.77454125383133, 53.8178084595192],
            [26.779897947396478, 53.81833551469509],
            [26.78436185929951, 53.81886256271167],
            [26.788825771202596, 53.81886256271167],
            [26.79552163815896, 53.819126084764605],
            [26.79953915833289, 53.819126084764605],
            [26.80578863445811, 53.81833551469509],
            [26.807574199578767, 53.81596371499802],
            [26.808913372969982, 53.81280110606059],
            [26.813377283974887, 53.81253754476461],
            [26.817394804148705, 53.814118888742314],
            [26.824537062834338, 53.81754492971078],
            [26.827215409616883, 53.820707180160355],
            [26.827215409616883, 53.82386919198217],
            [26.82275149861198, 53.82518662665814],
            [26.818287586708948, 53.827294435867316],
            [26.81650202248676, 53.83203661845221],
            [26.817841195877975, 53.83625144152853],
            [26.824090672003365, 53.83835869400792],
            [26.830786538959558, 53.83862209291328],
            [26.83748240591592, 53.83941228021888],
            [26.845071056330994, 53.84125599296419],
            [26.851766923287187, 53.84309962399834],
            [26.861141137026095, 53.84309962399834],
            [26.871854525054573, 53.845996594919654],
            [26.878996783740206, 53.84784001773971],
            [26.887031824087956, 53.849156698020636],
            [26.89055144549451, 53.85048544453059],
            [26.89819160294735, 53.85336979809529],
            [26.90220912312111, 53.856792629714164],
            [26.909351381806744, 53.86258447601131],
            [26.91247611942032, 53.865480098526405],
            [26.914708075371948, 53.87048115579836],
            [26.914261684540975, 53.87442893723909],
            [26.909797772637717, 53.8767974269208],
            [26.90711942585517, 53.87916578245847],
            [26.90711942585517, 53.882849624624725],
            [26.908012208415585, 53.8854807419649],
            [26.913815292811535, 53.88942710695824],
            [26.91872559554571, 53.89047940785639],
            [26.9249750716711, 53.89100554863501],
            [26.930331766134373, 53.89100554863501],
            [26.93658124225982, 53.88942710695824],
            [26.94059876243358, 53.88679623800749],
            [26.945509065167755, 53.88627004477007],
            [26.949526585341573, 53.88653314221665],
            [26.95532967063582, 53.889953260983646],
            [26.960686364200967, 53.89311004498694],
            [26.9651502752057, 53.89600355437386],
            [26.97139975133109, 53.90047494744675],
            [26.974524489842963, 53.90363093669856],
            [26.976756445794592, 53.908364474094526],
            [26.97764922745654, 53.91388625584],
            [26.98032757513738, 53.91625251024732],
            [26.987023442093744, 53.91730413618569],
            [26.99014817970715, 53.915989599888974],
            [26.991487353098535, 53.91257161194261],
            [26.99461209161035, 53.909416298155804],
            [26.999522394344353, 53.90783855186612],
            [27.00711104386096, 53.907575588533405],
            [27.010235781474535, 53.907575588533405],
            [27.017378040160168, 53.908364474094526],
            [27.02675225479743, 53.91151986734417],
            [27.027105224318234, 53.91172776919154],
          ],
        ],
      },
      properties: {
        shapeName: "Valozhyn",
        shapeISO: "",
        shapeID: "67162791B19881563690612",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
